export const STATIC_IMAGE_BASE = 'https://static.masterclass.com'
